import { getServiceAsync } from 'data/function';
import { ChatbotTestController } from 'modules/navbar/chatbotTest/ChatbotTestController';
import ChatbotTestView from 'modules/navbar/chatbotTest/ChatbotTestView.html';
const UNDER_CONSTRUCTION = 'construction';
export class ShowBlipChatProcessor {
    static async process({ message, trackingProperties, source }) {
        const loadingService = await getServiceAsync('LoadingService');
        try {
            loadingService.startLoading();
            const applicationService2 = await getServiceAsync('ApplicationService2');
            const sidebarContentService = await getServiceAsync('SidebarContentService');
            const application = {
                ...message.content.application,
                applicationJson: JSON.parse(message.content.application.builderSettings.Application),
            };
            await ShowBlipChatProcessor.updateUnderConstructionFlow(application, message);
            await sidebarContentService.showSidebar({
                controller: ChatbotTestController,
                controllerAs: '$ctrl',
                template: ChatbotTestView,
                appendToElement: document.getElementById('right-sidebar'),
                inputs: {
                    application: message.content.application,
                    ApplicationService2: applicationService2,
                    typeOfCompile: message.content.typeOfCompile,
                },
            });
        }
        catch (e) {
            const errorResponse = {
                error: e.toString(),
                trackingProperties,
            };
            source.postMessage(errorResponse, '*');
        }
        finally {
            loadingService.stopLoading();
        }
    }
    static async updateUnderConstructionFlow(application, message) {
        if (message.content.typeOfCompile !== UNDER_CONSTRUCTION) {
            return;
        }
        const builderService = await getServiceAsync('BuilderService');
        const [flow, configuration, globalActions] = await Promise.all([
            builderService.getFlow(message.content.application),
            builderService.getFlowConfiguration(),
            builderService.getGlobalActionsFromBucketOrNew(),
        ]);
        await builderService.publishFlow(flow, configuration, globalActions, application, application.applicationJson.settings.flow.id, message.content.typeOfCompile);
    }
}
